<template>
  <div class="animated fadeIn">
    <b-row v-if="templatesLoaded">
      <b-col lg="12" v-if="noTemplates">
        <b-card ><div class="d-flex justify-content-center">{{ $t('TEMPLATE.NOTHING') }}</div></b-card>
      </b-col>
      <b-col lg="12" v-else>
        <div class="pull-right views">
          <span>{{ $t('TEMPLATE_VIEW.VIEW') }}</span>
          <button type="button" class="btn btn-link" :disabled="!gridView">
            <i class="fa fa-th-list fa-lg mt-3" @click="toggleViews('table')"></i>
          </button>
          <button type="button" class="btn btn-link" :disabled="gridView">
            <i class="fa fa-th-large fa-lg mt-3" @click="toggleViews('grid')"></i>
          </button>
        </div>
      </b-col>
      <b-col v-if="gridView" lg="2" v-for="template in templateList" :key="template.id" class="template-container">
        <zoom-center-transition>
          <b-card show-footer>
            <img :src="(template.webp_thumbnail_url || template.thumbnail_url) | withBaseUrl" class="card-img"/>
            <div slot="footer" class="footer-text">
              {{ template.title.toUpperCase() | truncate(12, '...') }}<br>
              <span class="total-pages">{{ template.total_pages + $t('TEMPLATE_VIEW.PAGES') }}</span>
            </div>
            <div class="card-overlay">
              <router-link :to="{name: 'Train', params: {id: template.first_template_id}}" >
                <b-button size="sm" variant="outline-light">MAP TEMPLATE</b-button>
              </router-link>
              <div v-if = "!template.is_public" class="btn btn-public">
                <i @click="openSubmitFormStatusModal(template , true)" v-b-tooltip.hover :title="$t('TEMPLATE.ENABLE_FORM')" class="fa fa-user"></i>
              </div>
               <div v-else class="btn btn-public">
                <i @click="disableForm(template.id)" v-b-tooltip.hover :title="$t('TEMPLATE.DISABLE_FORM')" class="fa fa-user-times"></i>
              </div>
              <div v-if="isAdminRole" class="btn btn-link">
                <i @click="confirmModal(template)" class="fa fa-trash"></i>
              </div>
            </div>
          </b-card>
        </zoom-center-transition>
      </b-col>
      <b-col v-if="!gridView && !noTemplates" lg="12">
        <SearchBar @filterInput="setFilter" :title="$t('ROUTE_NAME.Template Listing')"/>
        <b-table striped hover responsive="sm" :items="templateList" :fields="tableFields" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
          <template slot="HEAD_id" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_title" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_total_pages" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_brand" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_updated_at" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="HEAD_actions" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="actions" slot-scope="data">
            <div class="btn-group">
              <router-link :to="{ name: 'Train', params: {id: data.item.first_template_id }}">
                <b-button variant="primary" class="first-button" v-b-tooltip.hover> {{ $t('TEMPLATE.TRAIN') }} </b-button>
              </router-link>
              <b-button v-if = "!data.item.is_public" @click="openSubmitFormStatusModal(data.item , true)" v-b-tooltip.hover :title="$t('TEMPLATE.ENABLE_FORM')" class="btn-public">
                <i class="fa fa-user"></i>
              </b-button>
               <b-button v-else @click="disableForm(data.item.id)" v-b-tooltip.hover :title="$t('TEMPLATE.DISABLE_FORM')" class="btn-public">
                <i class="fa fa-user-times"></i>
              </b-button>
              <b-button v-if="isAdminRole" @click="confirmModal(data.item)" variant="primary"  v-b-tooltip.hover :title="$t('COMMON.DELETE')" >
                <i class="fa fa-trash"></i>
              </b-button>
              <b-button class="last-button" @click="templateApi(data.item.id)" v-b-tooltip.hover title="Export to Rems">
                <i class="icon-cloud-upload" :ref="'export-rems-' + data.item.id"></i>
                <i class="fa fa-spin fa-spinner hide" :ref="'spinner-rems-' + data.item.id"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col lg="2" class="c-placeholder" v-for="loadingContent in templateLoadingContents" :key="loadingContent">
        <b-card>
          <content-placeholders >
            <content-placeholders-img style="height: 180px"/>
            <content-placeholders-text :lines="2"/>
          </content-placeholders>
        </b-card>
      </b-col>
    </b-row>
    <!--/.row-->
    <b-modal hide-header-close centered :title="$t('COMMON.DELETE_CONFIRM')" ref="tempModal" :ok-title="$t('COMMON.DELETE')" :cancel-title="$t('COMMON.CANCEL')" @ok="deleteTemplate" ok-variant="secondary" cancel-variant="light">
      {{ $t('TEMPLATE.DELETE_CONTENT', {'TEMPLATE_TITLE': seletedTemplateTitle}) }}
    </b-modal>

    <b-modal centered hide-header-close ref="submitFormStatus" title="Form Submission Configuration">
      <div>
        <b-row>
          <b-col>
            <p class="required">Note: Add any one of field to make it as a document title </p>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-form-group>
          <b-row>
            <b-col sm="4">
              <label>Page No</label>
              <span class="required">*</span>
            </b-col>
            <b-col>
              <b-form-select v-model="selectedPageNo" :options="pages"></b-form-select>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group v-if = "selectedPageNo">
          <b-row>
            <b-col sm="4">
              <label>Field</label>
              <span class="required">*</span>
            </b-col>
            <b-col>
              <b-form-select v-model="selectedField" :options="fields"></b-form-select>
            </b-col>
          </b-row>
        </b-form-group>
      </div>
      <div slot="modal-footer">
        <b-btn id ="addNewField" size="sm" variant="secondary" @click="enableForm()">{{ $t('COMMON.SAVE') }} </b-btn>
        <b-btn size="sm" variant="light" @click="$refs.submitFormStatus.hide()"> {{ $t('COMMON.CLOSE') }} </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import SearchBar from '../../components/utils/SearchBar'

export default {
  name: 'list',
  data () {
    return {
      seletedTemplateId: '',
      seletedTemplateTitle: '',
      templatesLoaded: false,
      templateLoadingContents: [1, 2, 3, 4, 5, 6],
      tableFields: [
        { key: 'id', sortable: true, label: 'TEMPLATE_VIEW.ID' },
        { key: 'title', sortable: true, label: 'COMMON.NAME' },
        { key: 'total_pages', sortable: true, label: 'TEMPLATE_VIEW.TOTAL_PAGES' },
        { key: 'brand', sortable: true, label: 'TEMPLATE_VIEW.BRAND' },
        { key: 'updated_at', sortable: true, label: 'TEMPLATE_VIEW.UPDATED_AT' },
        { key: 'actions', label: 'COMMON.ACTIONS' }
      ],
      users: [],
      gridView: false,
      filter: null,
      pages: [],
      selectedPageNo: null,
      fields: [],
      selectedField: null,
      sortDesc: true,
      sortBy: 'updated_at'
    }
  },
  components: {
    SearchBar
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      Vue.axios.get('template_docs', { headers: { Authorization: `Bearer ${vm.idToken}` }, params: {time_zone_offset: vm.localTime === 'true' ? new Date().getTimezoneOffset() : null} })
        .then(res => {
          vm.templatesLoaded = true
          vm.$store.commit('fetchTemplates', res.data.template_docs)
        })
        .catch(error => {
          if (error && error.status === 401) {
            Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            next(false)
          }
        })
    })
  },
  computed: {
    ...mapGetters(['templateList', 'noTemplates', 'idToken', 'isAdminRole', 'localTime'])
  },
  watch: {
    selectedPageNo: function (newSelected, oldSelected) {
      if (newSelected) {
        this.fetchFields()
      }
    }
  },
  methods: {
    ...mapActions(['removeTemplate']),
    confirmModal (temp) {
      this.seletedTemplateId = temp.id
      this.seletedTemplateTitle = temp.title
      this.$refs.tempModal.show()
    },
    deleteTemplate () {
      this.removeTemplate({id: this.seletedTemplateId})
      this.seletedTemplateId = ''
      this.seletedTemplateTitle = ''
    },
    toggleViews (viewType) {
      this.gridView = (viewType === 'grid')
    },
    templateApi (id) {
      let exportRef = this.$refs['export-rems-' + id]
      let spinnerRef = this.$refs['spinner-rems-' + id]
      exportRef.style.display = 'none'
      spinnerRef.style.display = 'inherit'
      Vue.axios.post('/rems/rems_sf/rems_export_template_mappings', {id}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
        })
        .catch(err => {
          console.log(err)
          spinnerRef.style.display = 'none'
          exportRef.style.display = 'inherit'
          Vue.toasted.show('failed during export', { icon: 'chain-broken', type: 'error' })
        })
    },
    setFilter (filter) {
      this.filter = filter
    },
    enableForm () {
      let payload = {
        template_doc_id: this.seletedTemplateId,
        is_public: true,
        template_mapping_id: this.selectedField
      }
      this.changeStatus(payload)
    },
    disableForm (templateDocId) {
      let payload = {
        template_doc_id: templateDocId,
        is_public: false
      }
      this.changeStatus(payload)
    },
    openSubmitFormStatusModal (currentTemplates, status) {
      this.seletedTemplateId = currentTemplates.id
      let templates = currentTemplates.templates
      this.selectedPageNo = null
      this.pages = [{ text: 'Select Page', value: null, disabled: true }].concat(templates.map(template => {
        return { text: 'Page ' + template.original_page_no, value: { id: template.id, latest_revision_id: template.latest_revision_id } }
      }))
      this.$refs.submitFormStatus.show()
    },
    changeStatus (payload) {
      Vue.axios.post('template_docs/modify_status', payload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            this.$store.state.templateList = this.templateList.map(template => {
              if (template.id === res.data.template_doc.id) {
                template.is_public = res.data.template_doc.is_public
              }
              return template
            })
            this.$refs.submitFormStatus.hide()
            Vue.toasted.show('Updated Sucessfully')
          } else {
            Vue.toasted.show(res.data.msg, { type: 'error' })
          }
        })
        .catch(error => {
          console.log(error)
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        })
    },
    fetchFields () {
      Vue.axios.get('templates/fetch_mappings_for_title', { headers: { Authorization: `Bearer ${this.idToken}` }, params: this.selectedPageNo })
        .then(res => {
          this.fields = res.data.mappings.map(field => {
            return { text: field.key, value: field.id }
          })
          this.selectedField = this.fields[0]['value']
        })
        .catch(error => {
          console.log(error)
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.views {
  word-spacing: 1rem;
  .btn-link {
    padding: 0 0 0.75rem;
    border: none;
    background: none;
  }
  span {
    font-size: 0.7rem;
  }
}

.card {
  background-color: #d8dfe6;
}
.card-body {
  padding: 0.75rem 0.75rem 0 0.75rem;
}
.card-img {
  width: 100%;
  border-style: none;
  height: 190px;
}
.card-footer {
  height: 55px;
  background-color: white;
}
.footer-text {
  margin-left: -0.4rem;
  line-height: 0.8rem;
}
.total-pages {
  opacity: 0.4;
  font-size: 0.7rem;
  display: inline-block;
  padding-top: .5rem;
}

.card-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 80%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  background-color: #0b192d;
  .btn-outline-light {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn-link {
    position: absolute;
    z-index: 1;
    color: white;
    right: 0;
  }
  .btn-public {
    position: absolute;
    z-index: 1;
    color: white;
    right: 0;
    margin-right: 21px;
  }
}
.template-container:hover .card-overlay {
  opacity: 1;
}
.c-placeholder { margin-top: 36px; }
.required {
  color: red;
}

.hide {
  display: none;
}

/deep/ .table.b-table>thead>tr>th.sorting_asc::after, table.b-table>thead>tr>th.sorting_desc::before, table.b-table>tfoot>tr>th.sorting_asc::after, table.b-table>tfoot>tr>th.sorting_desc::before {
    opacity: 1;
}
/deep/ .table.b-table>thead>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::after {
    right: 0.25em;
    content: "\2193";
}
/deep/ .table.b-table>thead>tr>th.sorting::before, table.b-table>thead>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::after {
    position: absolute;
    bottom: 3px;
    display: block;
    padding-bottom: inherit;
    font-size: inherit;
    line-height: 180%;
    transform: rotate(180deg);
}
/deep/ .table.b-table>thead>tr>th.sorting_asc::after, table.b-table>thead>tr>th.sorting_desc::before, table.b-table>tfoot>tr>th.sorting_asc::after, table.b-table>tfoot>tr>th.sorting_desc::before {
    opacity: 1;
}
/deep/ .table.b-table>thead>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::before {
    right: 0.75em;
    content: "\2191";
}
/deep/ .table.b-table>thead>tr>th.sorting::after, table.b-table>thead>tr>th.sorting::before, table.b-table>tfoot>tr>th.sorting::after, table.b-table>tfoot>tr>th.sorting::before {
    position: absolute;
    bottom: 3px;
    display: block;
    padding-bottom: inherit;
    font-size: inherit;
    line-height: 180%;
    transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/views/templates/List.vue